/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

export const MAPPED_AFNO = 0;
export const UNMAPPED_AFNO = 1;

export enum PromoTool {
  "LINK_CODE" = "LINK_CODE",
  "LIVE_CAMS" = "LIVE_CAMS",
  "PRE_ROLLS" = "PRE_ROLLS",
  "BANNERS" = "BANNERS",
  "FULL_PAGE_ADS" = "FULL_PAGE_ADS",
  "CATEGORY_BANNER" = "CATEGORY_BANNER",
  "LIVE_CAM_PRE_ROLLS" = "LIVE_CAM_PRE_ROLLS",
  "CAM_TAB_OVERLAY" = "CAM_TAB_OVERLAY",
}

export const PromoToolQueryMap: { [key: string]: PromoTool } = {
  "link-code": PromoTool.LINK_CODE,
  "live-cams": PromoTool.LIVE_CAMS,
  "pre-rolls": PromoTool.PRE_ROLLS,
  banners: PromoTool.BANNERS,
  "full-page-ads": PromoTool.FULL_PAGE_ADS,
  "category-banner": PromoTool.CATEGORY_BANNER,
  "live-cam-pre-rolls": PromoTool.LIVE_CAM_PRE_ROLLS,
  "cam-tab-overlay": PromoTool.CAM_TAB_OVERLAY,
};

// Gender? lol
export enum SiteGender {
  ALL = "all",
  STRAIGHT = "straight",
  GAY = "gay",
  TRANS = "trans",
}

export const LinkNicheMap = {
  all_girl_cams: "/",
  all_guys_cams: "webcam/guys",
  all_trans_cams: "webcam/trans",
  anal_sex: "webcam/anal-sex",
  asian: "webcam/asian-girls",
  babes: "webcam/babes",
  bbw: "webcam/bbw",
  big_tits: "webcam/big-tits",
  blonde: "webcam/blonde-girls",
  bondage: "webcam/bondage",
  brunette: "webcam/brunette-girls",
  couples: "webcam/straight-couples",
  curvy: "webcam/curvy",
  ebony: "webcam/ebony-girls",
  feet_fetish: "webcam/feet-fetish",
  gold_shows: "view/gold",
  granny: "webcam/granny",
  group_sex: "webcam/group-sex",
  hairy_pussy: "webcam/hairy-girls",
  homepage: "",
  housewives: "webcam/housewives",
  huge_tits: "webcam/huge-tits",
  latina: "webcam/latin-girls",
  lesbian: "webcam/lesbian-couples",
  live_model: "exports/golive",
  mature: "webcam/mature-women",
  medium_tits: "webcam/medium-tits",
  muscle: "webcam/muscle-girls",
  new_models: "view/new",
  non_nude: "webcam/non-nude/girlfriends",
  petite_body: "webcam/petite-girls",
  pornstar: "webcam/pornstars",
  pregnant: "webcam/pregnant-women",
  redhead: "webcam/redhead-girls",
  shaved_pussy: "webcam/shaved",
  small_tits: "webcam/small-tits",
  smoking: "webcam/smoking-cigars",
  "teen_18+": "webcam/teen-girls",
  toys: "webcam/girls-with-toys",
  trimmed_pussy: "webcam/trimmed",
  white_girls: "webcam/white-girls",
  random: "search-random",
  join_page: "signup/register",
} as const;

export const LiveModelQueryNicheMap = {
  home_page: "",
  anal: "&niche=anal",
  asian: "&niche=asian",
  big_tits: "&niche=bigtits",
  blonde: "&niche=blonde",
  brunette: "&niche=brunette",
  redhead: "&niche=redhead",
  bbw: "&niche=bbw",
  couples: "&niche=couples",
  ebony: "&niche=ebony",
  gay: "&niche=gay",
  latina: "&niche=latina",
  lesbian: "&niche=lesbian",
  mature: "&niche=mature",
  teen: "&niche=teen",
  trans: "&niche=trans",
} as const;

export const LiveCamPreRollsNicheMap = {
  home_page: "",
  asian: "&niche=asian",
  bbw: "&niche=bbw",
  big_tits: "&niche=bigtits",
  couples: "&niche=couples",
  ebony: "&niche=ebony",
  gay: "&niche=gay",
  granny: "&niche=granny",
  latina: "&niche=latina",
  milf: "&niche=milf",
  teen: "&niche=teen",
  trans: "&niche=trans",
} as const;

export const VastCampaignCategoryMap: {
  [category in AdCategory]: {
    [key: string]: { [contentType in BannerContentType]: number };
  };
} = {
  straight: {
    noOverlay: {
      nsfw: 4,
      sfw: 37,
    },
    overlay: {
      nsfw: 3,
      sfw: 38,
    },
  },
  trans: {
    noOverlay: {
      nsfw: 17,
      sfw: 39,
    },
    overlay: {
      nsfw: 18,
      sfw: 40,
    },
  },
  gay: {
    noOverlay: {
      nsfw: 19,
      sfw: 41,
    },
    overlay: {
      nsfw: 20,
      sfw: 42,
    },
  },
} as const;

export enum AdCategory {
  STRAIGHT = "straight",
  GAY = "gay",
  TRANS = "trans",
}

export enum NicheCategory {
  default = "default",
  asian = "asian",
  "teen_18+" = "teen_18+",
  bbw = "bbw",
  big_tits = "big_tits",
  ebony = "ebony",
  latina = "latina",
}

export enum BannerContentType {
  NSFW = "nsfw",
  SFW = "sfw",
}

export const BannerAdMap: {
  [size: string]: {
    width: number;
    height: number;
    categories: { [category in AdCategory]: { [contentType in BannerContentType]: number } };
  };
} = {
  "160x600": {
    width: 160,
    height: 600,
    categories: {
      gay: {
        nsfw: 9047,
        sfw: 9048,
      },
      straight: {
        nsfw: 9049,
        sfw: 9050,
      },
      trans: {
        nsfw: 9051,
        sfw: 9052,
      },
    },
  },
  "300x100": {
    width: 300,
    height: 100,
    categories: {
      gay: {
        nsfw: 9053,
        sfw: 9054,
      },
      straight: {
        nsfw: 9055,
        sfw: 9056,
      },
      trans: {
        nsfw: 9057,
        sfw: 9058,
      },
    },
  },
  "300x250": {
    width: 300,
    height: 250,
    categories: {
      gay: {
        nsfw: 9059,
        sfw: 9061,
      },
      straight: {
        nsfw: 9062,
        sfw: 9063,
      },
      trans: {
        nsfw: 9064,
        sfw: 9065,
      },
    },
  },
  "728x90": {
    width: 728,
    height: 90,
    categories: {
      gay: {
        nsfw: 9066,
        sfw: 9067,
      },
      straight: {
        nsfw: 9068,
        sfw: 9069,
      },
      trans: {
        nsfw: 9070,
        sfw: 9076,
      },
    },
  },
} as const;

export enum Platform {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export const FullPageAdVideoIdNicheMap: { [category in NicheCategory]: number } = {
  [NicheCategory.default]: 9028,
  [NicheCategory.asian]: 9705,
  [NicheCategory.bbw]: 9707,
  [NicheCategory.big_tits]: 9708,
  [NicheCategory.ebony]: 9709,
  [NicheCategory.latina]: 9710,
  [NicheCategory["teen_18+"]]: 9706,
};

export const FullPageAdVideoIdMap: { [category in AdCategory]: number } = {
  [AdCategory.STRAIGHT]: 9028,
  [AdCategory.GAY]: 9029,
  [AdCategory.TRANS]: 9030,
};

export const FullPageAdLinkTemplateMap: {
  [category in AdCategory]: { [platform in Platform]: { [template: number]: string } };
} = {
  [AdCategory.STRAIGHT]: {
    [Platform.MOBILE]: {
      0: "https://[[BASEURL]]/landing/mobile-landers/mg-2column-timeline/?v=new-style-with-canned-header&vidChoice=fm&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      1: "https://as.sexad.net/as/pu?p=reseller&v=8414&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/mobile-landers/scp-cats-v3/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/mobile-landers/top-cats/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/mobile-landers/top-cats-v2/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/mobile-landers/sexy-tour-RR-no-scroll/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/mobile-landers/scp-cats-lessBusy-catSwitch/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/mobile-landers/top-cats-dropdown/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      8: "https://[[BASEURL]]/landing/mobile-landers/sexy-tour-RR-no-scroll/?HTML_v=montage&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      9: "https://[[BASEURL]]/landing/mobile-landers/mg-2column-timeline/?v=new-style-with-canned-header&vidChoice=ji&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
    [Platform.DESKTOP]: {
      1: "https://as.sexad.net/as/pu?p=reseller&v=8415&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/san3/sexy-tour-RR/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/san3/scroll-tour/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/san3/sexy-tour-t1/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/san3/niche-tour/?niche=fem&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/san3/sexy-tour-BR/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/san3/sexy-tour-RR-no-scroll-android/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      8: "https://[[BASEURL]]/landing/san3/minisite/?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
  },
  [AdCategory.GAY]: {
    [Platform.MOBILE]: {
      1: "https://as.sexad.net/as/pu?p=reseller&v=8417&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/mobile-landers/gay-top-cats/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/mobile-landers/gay-no-top-cats/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=brazilian_gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/scp-cats-lessBusy-BR/?niche=brazilian_gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/mobile-landers/mg-2column-timeline-gay/?vidChoice=sm&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
    [Platform.DESKTOP]: {
      1: "https://as.sexad.net/as/pu?p=reseller&v=8416&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-gay/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-gay/index2.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-gay/index3.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/san3/scroll-tour/gay-01.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/san3/scroll-tour/gay-02.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      8: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=brazilian_gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      "9": "https://[[BASEURL]]/landing/san3/sexy-tour-BR/?niche=brazilian_gay&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
  },
  [AdCategory.TRANS]: {
    [Platform.MOBILE]: {
      1: "https://as.sexad.net/as/pu?p=reseller&v=8419&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/mobile-landers/trans-no-top-cats/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/mobile-landers/trans-top-cats/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index2.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index3.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/mobile-landers/mg-2column-timeline-more/?vidChoice=montage&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
    [Platform.DESKTOP]: {
      1: "https://as.sexad.net/as/pu?p=reseller&v=8418&wl=[[BASEURL]]&afno=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      2: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      3: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index2.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      4: "https://[[BASEURL]]/landing/san3/sexy-tour-simple-trans/index3.html?AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      5: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=trans&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      6: "https://[[BASEURL]]/landing/templates/niche-tour/index.html?niche=brazilian_trans&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
      7: "https://[[BASEURL]]/landing/san3/sexy-tour-BR/?niche=brazilian_trans&AFNO=[[AFNOPREFIX]][[AFNO]]&HTML_w=0",
    },
  },
};

export const BannerCategoryGenderMap: { [key in AdCategory]: string } = {
  [AdCategory.STRAIGHT]: "female",
  [AdCategory.GAY]: "male",
  [AdCategory.TRANS]: "transgender",
} as const;

export enum AdStyles {
  ROTATION = 9933,
  CIRCLE = 9932,
  SQUARE = 5104,
}
